/*
 * @Author: zhangyaowen zhangyaowen_520@163.com
 * @Date: 2022-03-07 10:07:41
 * @LastEditors: zhangyaowen zhangyaowen_520@163.com
 * @LastEditTime: 2022-06-14 09:43:13
 * @FilePath: \smart-community\src\api\eventManagement\eventManagementApi.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "@/utils/request";

// 分配列表
export const eventlist = data => {
  return request({
    url: "/api/hz-smart-community/event/list",
    data: data,
    method: 'POST'
  });
};
// 任务导出
export const eventexport = data => {
  return request({
    url: "/api/hz-smart-community/event/export",
    data: data,
    responseType: "blob",
    method: 'POST'
  });
};
// 事件记录导出
export const eventexportRecord = data => {
  return request({
    url: "/api/hz-smart-community/event/exportRecord",
    data: data,
    responseType: "blob",
    method: 'POST'
  });
};
// 分配任务
export const eventassign = data => {
  return request({
    url: "/api/hz-smart-community/event/assign",
    data: data,
    method: 'POST'
  });
};
// 事件的处理
export const eventhandle = data => {
  return request({
    url: "/api/hz-smart-community/event/handle",
    data: data,
    method: 'POST'
  });
};
// 详情列表
export const eventqueryAssignEvent = data => {
  return request({
    url: "/api/hz-smart-community/event/queryAssignEvent",
    data: data,
    method: 'POST'
  });
};